import React, { useEffect, useState } from 'react';
import {
  Divider, Form, Radio,
} from '@roo/roo';
import { getNominator } from '@assets/apis/scientist';
import {
  renderDetailByColumns,
  renderDetailListByColumns,
  defaultCols as cols,
  renderFileForPreview,
  renderEditor,
  renderFile,
} from './util';

import '../index.scss';

const { Group: RadioGroup } = Radio;

const nominatorColumns = [{
  label: '提名码',
  key: 'code',
}, {
  label: '提名人',
  key: 'name',
}, {
  label: '提名人职务',
  key: 'position',
}, {
  label: '提名人工作单位',
  key: 'organization',
},
{
  label: '提名理由',
  key: 'nominationType',
  _render: (info, nominationType) =>
    // console.log(info,nominationType,'=====--',info[nominationType] === 'file');
    (info[nominationType] === 'file' ? renderFile(info, 'nominationUrl') : (<span className="control-field">{String(info.nominationText || '')}</span>)),

},
];

const recommendColumns = [{
  label: '推荐人姓名',
  key: 'name',
}, {
  label: '工作单位',
  key: 'company',
}, {
  label: <span>&nbsp;&nbsp;职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</span>,
  key: 'job',
  required: false,
}, {
  label: <span>&nbsp;&nbsp;手机号码</span>,
  key: 'phone',
  required: false,
}, {
  label: '电子邮箱',
  key: 'email',
}];

const recommendColumnsForJudge = recommendColumns.concat({
  label: <span>推&nbsp;&nbsp;荐&nbsp;&nbsp;函</span>,
  key: 'letterUrl',
  layout: 'vertical',
  _render: renderFileForPreview,
});

const researchOverviewColumns = [{
  label: '科研及学术成就介绍',
  key: 'achievement',
  layout: 'vertical',
  _render: renderEditor,
}, {
  label: '在研科研项目及学术进展',
  key: 'progress',
  layout: 'vertical',
  _render: renderEditor,
}, {
  label: '未来五年科研工作规划',
  key: 'futurePlan',
  layout: 'vertical',
  _render: renderEditor,
}, {
  label: '个人研究方向对相关议题研究的贡献和价值',
  key: 'contribution',
  layout: 'vertical',
  _render: renderEditor,
}];

const attachmentColumns = [{
  label: '附件',
  key: 'overviewFile',
  layout: 'vertical',
  _render: renderFile,
}];

export default ({ detail: applyInfo, isView = false }) => {
  const [nominatorInfo, setNominatorInfo] = useState([]);
  const {
    recommendInfo, researchOverview, isNominated, nominationInfo, researchOverviewFileKeyMap,
  } = applyInfo;
  window.GreenFileKey = researchOverviewFileKeyMap || {};

  useEffect(() => {
    const codeList = nominationInfo?.map((item) => item.code).filter(Boolean);
    if (isNominated && codeList && codeList.length) {
      getNominator(codeList.join(','))
        .then((res) => {
          const nominatorInfo = res.nominators;
          setNominatorInfo(nominatorInfo);
        });
    }
  }, []);
  return (
    <>
      <h3 id="nomination" className="catalogue-tag">是否提名</h3>
      <Divider />
      <div className="preview-item-wrap">
        <div className="preview-item-wrap-withoutbackground">
          <Form cols={cols}>
            <Form.Field
              label="是否提名"
              required
              className="preview-item-text"
            >
              <div>
                <RadioGroup value={!!isNominated}>
                  <Radio
                    value={false}
                    disabled
                  >
                    推荐申报
                  </Radio>
                  <Radio
                    value
                    disabled
                  >
                    提名申报
                  </Radio>
                </RadioGroup>
              </div>
            </Form.Field>
          </Form>
        </div>
      </div>
      {
        isNominated ? (
          <>
            <div className="preview-label-wrap">
              <h3 id="recommend" className="catalogue-tag">提名信息</h3>
            </div>
            <Divider />
            {
              renderDetailListByColumns(nominatorInfo, nominatorColumns)
            }
          </>
        ) : (
          <>
            <div className="preview-label-wrap">
              <h3 id="recommend" className="catalogue-tag">推荐信息</h3>
              <span className="preview-tips">请上传2份以上的推荐信息</span>
            </div>
            <Divider />
            {
              renderDetailListByColumns(recommendInfo, isView ? recommendColumnsForJudge : recommendColumns)
            }
          </>
        )
      }
      <h3 id="researchOverview" className="catalogue-tag">个人科研成就、进展及规划</h3>
      <Divider />

      {
        researchOverview?.fillInType === 'uploadFile' ? renderDetailByColumns(researchOverview, attachmentColumns) : null
      }
      {
        researchOverview?.fillInType === 'onlineFillIn' ? renderDetailByColumns(researchOverview, researchOverviewColumns) : null
      }
    </>
  );
};
